import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@assets/img/Icons/group-4.svg'


const _hoisted_1 = { class: "authentication_box" }
const _hoisted_2 = { class: "content_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "img_wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "img_box" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Img"
    })
  ])
], -1)
const _hoisted_4 = { class: "text_box" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=ru"
}, "Google Authenticator", -1)
const _hoisted_6 = { class: "qr_container" }
const _hoisted_7 = { class: "qr_box" }
const _hoisted_8 = {
  key: 0,
  class: "qr_img"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "qr_img"
}
const _hoisted_11 = {
  class: "btn_box",
  id: "close-auth-qr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_aba_button_right = _resolveComponent("aba-button-right")!
  const _component_modal_fullscreen = _resolveComponent("modal-fullscreen")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_modal_fullscreen, {
      visible: _ctx.visible,
      onClose: _ctx.close
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("TwoFactorAuth")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("DownloadFreeApp")) + " ", 1),
                _hoisted_5,
                _createTextVNode(", " + _toDisplayString(_ctx.$localization.getTranslate(
										"ClickAddAndThenScanThisQRCodeToSetUpAnAccount"
									)) + ". ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.srcQr !== undefined && _ctx.srcQr !== '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.srcQr,
                      alt: "qr"
                    }, null, 8, _hoisted_9)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createVNode(_component_loading, { style: { height: `200px` } })
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_aba_button_right, { onClick: _ctx.changeDefense }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Continue")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ]))
}